import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import CurrencyDataPod from '../../../components/CurrencyDataPod';

const messages = defineMessages({
  title: {
    id: 'hubs.costs.annual-room-and-board.title',
    defaultMessage: 'Annual Room And Board',
  },
  linkText: {
    id: 'hubs.costs.annual-room-and-board.link-text',
    defaultMessage: 'Learn more about cost',
  },
});

function RoomAndBoard({ roomAndBoard, intl, lastUpdated }) {
  const title = intl.formatMessage(messages.title);

  return roomAndBoard && !Number.isNaN(+roomAndBoard) ? (
    <CurrencyDataPod
      header={title}
      footer={lastUpdated}
      ariaLabel={`${title}, $${roomAndBoard}`}
      content={{
        currencyValues: [roomAndBoard],
        linkText: intl.formatMessage(messages.linkText),
        linkUrl: 'Costs#tuitionandfees',
      }}
    />
  ) : null;
}

export default injectIntl(RoomAndBoard);

RoomAndBoard.propTypes = {
  roomAndBoard: PropTypes.string,
  lastUpdated: PropTypes.string,
  intl: PropTypes.object,
};
